import React, { useMemo } from 'react'
import { useGetContactFieldName } from 'src/editor/hooks/use-get-contact-field-name'
import { CommonEditorFieldEntityOrSubEntity } from 'src/editor/shared/components/field/common-editor-field-entity-or-sub-entity'
import { FormInterface } from 'src/shared/entities/form/form.schema'
import { FormFieldInterface } from 'src/shared/entities/form/form-field-sub-entity.schema'
import { FormBaseSubEntity } from './form-base-sub-entity'

interface FormFieldSubEntityProps {
  formEntity: FormInterface
  fieldSubEntity: FormFieldInterface
}

export const FormFieldSubEntity = ({
  formEntity,
  fieldSubEntity,
}: FormFieldSubEntityProps) => {
  const getContactFieldName = useGetContactFieldName()

  const entity = useMemo(
    () => ({
      ...fieldSubEntity,
      ...formEntity.fieldsCommonStyles,
    }),
    [fieldSubEntity, formEntity.fieldsCommonStyles],
  )

  return (
    <FormBaseSubEntity
      title={getContactFieldName(fieldSubEntity.slug)}
      formEntity={formEntity}
      subEntity={fieldSubEntity}
    >
      <CommonEditorFieldEntityOrSubEntity entityOrSubEntity={entity} />
    </FormBaseSubEntity>
  )
}
